import script from "./ClipPropertyEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClipPropertyEditor.vue?vue&type=script&setup=true&lang=ts"

import "./ClipPropertyEditor.vue?vue&type=style&index=0&id=4a462624&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.30_vue@3.5.27_typescript@5.9.3__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a462624"]])

export default __exports__